import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AtpHttpService, IAtpUser } from '../services/atp-http.service';
import { Location } from '@angular/common';

@Injectable()
export class AtpAuthGuard implements CanActivate {

  constructor(private _router: Router, private _api: AtpHttpService<IAtpUser>, private _location: Location) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this._api.user && this._api.token) {
      return true;
    }

    // not logged in so redirect to login page
    this._router.navigate(['/auth']);
    return false;
  }
}